import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { LeadFormModule } from '../form';
import { LeadFormInfoModule } from '../form-info';

import { LeadFormContainerComponent } from './lead-form-container.component';

@NgModule({
    imports: [
        SharedModule,
        LeadFormModule,
        LeadFormInfoModule
    ],
    declarations: [
        LeadFormContainerComponent
    ],
    exports: [
        LeadFormContainerComponent
    ]
})
export class LeadFormContainerModule { }
